export default __webpack_public_path__ + "static/media/alert-triangle.ce05e654.svg";